import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {PageQueryInterface} from "../_models/page.interface";

@Injectable({
    providedIn: 'root',
})
export class ScorecardService {
    private readonly SCORECARD_API: string;

    constructor(private http: HttpClient) {
        this.SCORECARD_API = `${environment.apiUrl}/scorecard/`;
    }

    async getAll(pageQuery: PageQueryInterface, userId: number): Promise<any> {
        return await this.http.post(this.SCORECARD_API + `get-scorecards/${userId}`, pageQuery).toPromise();
    }
    async getAllUser(pageQuery: PageQueryInterface): Promise<any> {
        return await this.http.post(this.SCORECARD_API + `get-user-scorecards`, pageQuery).toPromise();
    }

    async getByIdAndUserId(id: number, userId: number): Promise<any> {
        return await this.http.get(this.SCORECARD_API + `get-by-id?id=${id}&userId=${userId}`).toPromise();
    }

    async getById(id: number): Promise<any> {
        return await this.http.get(this.SCORECARD_API + `get-scorecard-by-id?id=${id}`).toPromise();
    }

    async save(payload: any): Promise<any> {
        return await this.http.post(this.SCORECARD_API + `scorecard`, payload).toPromise();
    }

    async update(payload: any): Promise<any> {
        return await this.http.put(this.SCORECARD_API + `scorecard`, payload).toPromise();
    }

    async deleteScorecard(scorecardId: number, userId: number): Promise<any> {
        return await this.http.post(this.SCORECARD_API + `delete-scorecard?scorecardId=${scorecardId}&userId=${userId}`, {}).toPromise();
    }
}